import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';

export const MIN_PASSWORD_LENGTH = 8;

interface UpdatePasswordInput {
    email: string;
    password: string;
    /** From `POST /account/otp/verify`; the only credential the reset accepts. */
    resetToken: string;
}

const updatePassword = async (input: UpdatePasswordInput) =>
    axios.post(`${API_URL}/account/password`, input);

export const useUpdatePassword = () => {
    return useMutation({
        mutationFn: updatePassword,
    });
};
